import { Widget } from '@sprinklr/stories/widget/Widget';
import { getPxPosition } from 'utils/Number/NumberUtils';
import { toJS } from 'mobx';
import { PxPosition, PxPositionMap } from 'services/WidgetService/WidgetService';

export function getGridStyles(widget: Widget) {
    const { columns, rows } = widget.position.grid;
    const styles: React.CSSProperties = {
        gridColumn: `${parseInt((columns.start as unknown) as string) + 1} / ${parseInt(
            (columns.end as unknown) as string
        ) + 1}`,
        gridRow: `${parseInt((rows.start as unknown) as string) + 1} / ${parseInt(
            (rows.end as unknown) as string
        ) + 1}`,
        width: '100%',
        height: '100%',
    };
    return styles;
}

export function getPositionMap(widgetNodes: NodeListOf<Element>) {
    return (Array.from(widgetNodes) as HTMLElement[]).reduce((prev, curr) => {
        const widgetId = Array.from(curr.classList)
            .find(classString => classString.includes('widget_id'))
            .split('_')
            .pop();
        return {
            ...prev,
            [widgetId]: {
                top: curr.offsetTop,
                left: curr.offsetLeft,
                width: curr.offsetWidth,
                height: curr.offsetHeight,
            },
        };
    }, {});
}

export function getPosition({
    widgetId,
    widgetPositions,
}: {
    widgetId: string;
    widgetPositions: PxPositionMap;
}) {
    const position: PxPosition = widgetPositions?.[widgetId.split('_').pop()];
    const { top: y, left: x, height, width } = position || {};
    return { y, x, height, width };
}
